import homePageTranslationsDE from 'Pods/NewHomepage/Locales/homepagetranslationsDE.json'
import homePageTranslationsEN from 'Pods/NewHomepage/Locales/homepagetranslationsEN.json'
import homePageTranslationsES from 'Pods/NewHomepage/Locales/homepagetranslationsES.json'
import homePageTranslationsFR from 'Pods/NewHomepage/Locales/homepagetranslationsFR.json'
import homePageTranslationsJP from 'Pods/NewHomepage/Locales/homepagetranslationsJP.json'
import homePageTranslationsPT from 'Pods/NewHomepage/Locales/homepagetranslationsPT.json'
import homePageTranslationsRU from 'Pods/NewHomepage/Locales/homepagetranslationsRU.json'
import homePageTranslationsZHCN from 'Pods/NewHomepage/Locales/homepagetranslationsZHCN.json'
import i18n from 'Pods/Shared/I18n'

// Add the new-home namespace to the existing i18n instance
i18n.addResourceBundle('en', 'new-home', homePageTranslationsEN, true, true)
i18n.addResourceBundle('de', 'new-home', homePageTranslationsDE, true, true)
i18n.addResourceBundle('es', 'new-home', homePageTranslationsES, true, true)
i18n.addResourceBundle('fr', 'new-home', homePageTranslationsFR, true, true)
i18n.addResourceBundle('ja', 'new-home', homePageTranslationsJP, true, true)
i18n.addResourceBundle('pt', 'new-home', homePageTranslationsPT, true, true)
i18n.addResourceBundle('ru', 'new-home', homePageTranslationsRU, true, true)
i18n.addResourceBundle('zh-CN', 'new-home', homePageTranslationsZHCN, true, true)

export default i18n
